import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import {
  FaTachometerAlt,
  FaUsers,
  FaCog,
  FaBuilding,
  FaChartLine,
  FaBell,
} from "react-icons/fa";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useLocation, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [settingsDropdownOpen, setSettingsDropdownOpen] = useState(false);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    console.log(user);
  }, [user]);
  // Auto-open dropdowns if child routes are active
  useEffect(() => {
    if (
      location.pathname.startsWith("/manager") ||
      location.pathname.startsWith("/employees") ||
      location.pathname.startsWith("/supervisor")
    ) {
      setUserDropdownOpen(true);
    }

    if (
      location.pathname.startsWith("/departments") ||
      location.pathname.startsWith("/default-baseline")
    ) {
      setSettingsDropdownOpen(true);
    }
  }, [location.pathname]);

  return (
    <div className={`sidebar sidebar-overlay bg-white ${isOpen ? "show" : ""}`}>
      <div className="d-flex flex-column h-100">
        <Nav className="flex-column p-3 pt-4">
          {/* Dashboard Link */}
          <NavLink
            to="/"
            className={({ isActive }) =>
              `sidebar-link mb-3 d-flex text-decoration-none align-items-center p-2 rounded-3 ${
                isActive
                  ? "active text-primary fw-bold bg-primary-light"
                  : "text-dark hover-bg-light"
              }`
            }
            onClick={onClose}
          >
            <FaTachometerAlt className="me-2" />
            Dashboard
          </NavLink>

          {/* User Management Section */}
          <div className="mb-3">
            <div
              className="d-flex align-items-center justify-content-between p-2 rounded-3 hover-bg-light"
              onClick={() => setUserDropdownOpen(!userDropdownOpen)}
              style={{ cursor: "pointer" }}
            >
              <span className="d-flex align-items-center">
                <FaUsers className="me-2" />
                User Management
              </span>
              {userDropdownOpen ? (
                <MdKeyboardArrowUp />
              ) : (
                <MdKeyboardArrowDown />
              )}
            </div>

            {userDropdownOpen && (
              <div className="ms-4 mt-2 d-flex flex-column gap-1">
                {user?.user_type !== "manager" && (
                  <NavLink
                    to="/manager"
                    className={({ isActive }) =>
                      `px-3 py-2 sidebar-link rounded-3 text-decoration-none ${
                        isActive
                          ? "active text-primary fw-bold bg-primary-light"
                          : "text-dark hover-bg-light"
                      }`
                    }
                    onClick={onClose}
                  >
                    Managers
                  </NavLink>
                )}

                <NavLink
                  to="/supervisor"
                  className={({ isActive }) =>
                    `px-3 py-2 sidebar-link rounded-3 text-decoration-none ${
                      isActive
                        ? "active text-primary fw-bold bg-primary-light"
                        : "text-dark hover-bg-light"
                    }`
                  }
                  onClick={onClose}
                >
                  Supervisors
                </NavLink>

                <NavLink
                  to="/employees"
                  className={({ isActive }) =>
                    `px-3 py-2 sidebar-link rounded-3 text-decoration-none ${
                      isActive
                        ? "active text-primary fw-bold bg-primary-light"
                        : "text-dark hover-bg-light"
                    }`
                  }
                  onClick={onClose}
                >
                  Employees
                </NavLink>
              </div>
            )}
          </div>

          {/* Send Notification Link */}
          <NavLink
            to="/send-notification"
            className={({ isActive }) =>
              `sidebar-link mb-3 d-flex text-decoration-none align-items-center p-2 rounded-3 ${
                isActive
                  ? "active text-primary fw-bold bg-primary-light"
                  : "text-dark hover-bg-light"
              }`
            }
            onClick={onClose}
          >
            <FaBell className="me-2" />
            Send Notification
          </NavLink>
          {/* Settings Section at bottom */}
          <div className="mt-auto">
            <div className="mb-3">
              <div
                className="d-flex align-items-center justify-content-between p-2 rounded-3 hover-bg-light"
                onClick={() => setSettingsDropdownOpen(!settingsDropdownOpen)}
                style={{ cursor: "pointer" }}
              >
                <span className="d-flex align-items-center">
                  <FaCog className="me-2" />
                  Settings
                </span>
                {settingsDropdownOpen ? (
                  <MdKeyboardArrowUp />
                ) : (
                  <MdKeyboardArrowDown />
                )}
              </div>

              {settingsDropdownOpen && (
                <div className="ms-4 mt-2 d-flex flex-column gap-1">
                  {user?.user_type !== "manager" && (
                    <NavLink
                      to="/departments"
                      className={({ isActive }) =>
                        `px-3 py-2 sidebar-link rounded-3 text-decoration-none ${
                          isActive
                            ? "active text-primary fw-bold bg-primary-light"
                            : "text-dark hover-bg-light"
                        }`
                      }
                      onClick={onClose}
                    >
                      {/* <FaBuilding className="me-2" /> */}
                      Departments
                    </NavLink>
                  )}

                  <NavLink
                    to="/subdepartments"
                    className={({ isActive }) =>
                      `px-3 py-2 sidebar-link rounded-3 text-decoration-none ${
                        isActive
                          ? "active text-primary fw-bold bg-primary-light"
                          : "text-dark hover-bg-light"
                      }`
                    }
                    onClick={onClose}
                  >
                    {/* <FaBuilding className="me-2" /> */}
                    Subdepartments
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        </Nav>
      </div>
    </div>
  );
};

export default Sidebar;

// Add this to your CSS file
// .bg-primary-light {
//   background-color: rgba(13, 110, 253, 0.1);
// }
// .hover-bg-light:hover {
//   background-color: rgba(0, 0, 0, 0.05);
// }
// .sidebar-link {
//   transition: all 0.2s ease;
// }
